<template>
<Box @close="close({})">
    <template #top>Registrar Orden de Pago</template>
    <template #center>
        <div v-if="orden_pago">
            <div class="nj-cols">
                <div class="nj-panel">
                    <div class="nj-panel-content">
                        <div class="nj-subtitle-1">Orden de Pago</div>
                        <div class="nj-grid">
                            <InputText label="Descripción" v-model="orden_pago.opg_descripcion" :focus="true"></InputText>
                            <InputDate label="Fecha de pago programado" v-model="orden_pago.opg_fecha_pago_programado"></InputDate>
                            <InputSelect label="Pago de cierre" v-model="orden_pago.opg_pago_cierre" :source="pago_cierre" itemKey="id" itemValue="id" itemFilter="descripcion"
                                :labelFunction="(item) => item.descripcion">
                                <template #default="data">
                                    {{ data.item.descripcion }}
                                </template>
                            </InputSelect>
                        </div>
                        <div class="nj-grid">
                            <InputText type="number" label="Total" v-model="orden_pago.opg_total" @enter="calcular()"></InputText>
                            <InputText type="number" label="Tasa detracción" v-model="tasa_detraccion" @enter="calcular()"></InputText>
                            <InputText type="number" label="Detracción" v-model="orden_pago.opg_detraccion" :disabled="true"></InputText>
                            <InputText type="number" label="Pago" v-model="orden_pago.opg_pago" :disabled="true"></InputText>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template #bottom>
        <Upload label="Documento" v-model="pdf"></Upload>
        <Button label="Registrar" icon="save" color="green" @click="registrar()"></Button>
    </template>
</Box>
</template>

<script>
import { mapActions } from "vuex"
import { OrdenCompraService, OrdenPagoService, ResponseStatus, UsuarioService } from "../../rest"
import { DateTime, Tools } from "../../util"
import Toast from "../../util/toast"
import { Box, Button, InputDate, Help, InputSelect, InputText, InputUpload, Upload } from "../components"
import OrdenCompraData from "./OrdenCompraData.vue"

export default {
    name: "RegistrarOrdenPago",
    components: {
        OrdenCompraData,
        InputText,
        InputSelect,
        InputUpload,
        Button,
        Upload,
        InputDate,
        Box,
        Help,
    },
    props: {
        ord_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            // recordar definir e inicializar los atributos de los objects 
            // para manipularlos en la interfaz
            orden_pago: {
                opg_creador: UsuarioService.getUsuario().usu_id,
                opg_total: null,
                opg_detraccion: null,
                opg_pago: null,
                opg_pago_cierre: null,
                opg_fecha_pago_programado: null,
            },
            pago_cierre: [
                {
                    id: "0",
                    descripcion: "No aplicar cierre"
                },
                {
                    id: "1",
                    descripcion: "Aplicar cierre"
                }
            ],
            tasa_detraccion: 0,
            pdf: null,
        }
    },
    computed: {

    },
    methods: {
        ...mapActions("AppStore", [
            "_loadingOn",
            "_loadingOff",
        ]),
        adjuntarPdf(opg_id) {
            this._loadingOn()
            let interval = setInterval(() => {
                OrdenPagoService.adjuntarPdf(this.pdf, opg_id).then(
                    response => {
                        Toast.success(response.message)
                        this.regresar()
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
                clearInterval(interval)
                this._loadingOff()
            }, 1000)
        },
        registrar() {
            this.orden_pago.opg_creador = UsuarioService.getUsuario().usu_id
            Tools.validate([
                this.orden_pago.opg_creador,
                this.orden_pago.opg_descripcion,
                this.orden_pago.opg_fecha_pago_programado,
                this.orden_pago.opg_total,
                this.orden_pago.opg_pago_cierre,
            ], "Falta ingresar datos para registrar la orden de pago")
            OrdenPagoService
                .registrar({
                    orden_pago: this.orden_pago
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                        this.close({
                            buscar_ordenes_pago: true,
                        })
                    }
                    else {
                        Toast.warn(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        close({
            interfaz = "none",
            buscar_ordenes_pago = false,
            buscar_datos_orden = false
        }) {
            this.$emit("close", {
                interfaz,
                buscar_ordenes_pago,
                buscar_datos_orden,
            })
        },
        calcular() {
            this.orden_pago.opg_detraccion = parseFloat(this.orden_pago.opg_total).toFixed(2) * parseFloat(this.tasa_detraccion).toFixed(2)
            this.orden_pago.opg_pago = this.orden_pago.opg_total - this.orden_pago.opg_detraccion
        },
    },
    mounted() {
        // obteniendo la orden de compra
        OrdenCompraService
            .obtener({
                orden_compra: {
                    ord_id: this.ord_id
                }
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    const orden_compra = response.data
                    // obteniendo la tasa de la detracción
                    this.tasa_detraccion = orden_compra.ori_detraccion
                    this.orden_pago.ord_id = orden_compra.ord_id
                    this.orden_pago.opg_pago_cierre = "0"
                    this.orden_pago.opg_fecha_pago_programado = DateTime.getDateString()
                }
                else {
                    Toast.warn(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    },

}
</script>
<style scoped></style>